import React, { Component } from 'react';

class Loader extends Component {
    render() {
        const styles = {
            display: '-webkit-flex',
            display: 'flex',
            WebkitFlex: '0 1 auto',
            flex: '0 1 auto',
            WebkitFlexDirection: 'column',
            flexDirection: 'column',
            WebkitFlexGrow: 1,
            flexGrow: 1,
            WebkitFlexShrink: 0,
            flexShrink: 0,
            WebkitFlexBasis: '100%',
            flexBasis: '100%',
            maxWidth: '100%',
            height: '200px',
            WebkitAlignItems: 'center',
            alignItems: 'center',
            WebkitJustifyContent: 'center',
            justifyContent: 'center',
            color: 'tomato'
        };

        return (
            <div style={ styles }>
                <img src="/images/in-touch-spinner.gif" alt="Loading..."/>
            </div>
        );
    };
}

export default Loader;



// WEBPACK FOOTER //
// src/client/components/common/elements/Loader.js